export const events = {
  ERROR: 'Error',
  RECORDING_COMPLETE: 'Recording Complete',
  UPLOAD_STARTED: 'Upload Started',
  UPLOAD_PAUSED: 'Upload Paused',
  UPLOAD_COMPLETE: 'Upload Complete',
  CLICKED_THANK_YOU_LINK: 'Clicked Thank You Screen Link',
};
